// Lingue supportate dall'interfaccia: unica fonte di verità lato client (la
// controparte del server è server/utils/languages.js — vanno tenute allineate).
// L'ordine è quello in cui compaiono bandiere e schede lingua.
export const LANGUAGES = [
  { key: 'it', label: 'Italiano', flag: '🇮🇹' },
  { key: 'en', label: 'English', flag: '🇬🇧' },
  { key: 'ro', label: 'Română', flag: '🇷🇴' },
];

export const LANGUAGE_KEYS = LANGUAGES.map((l) => l.key);

// Attive finché il super-admin non salva una configurazione: quelle storiche
export const DEFAULT_ENABLED_LANGUAGES = ['it', 'en'];
export const FALLBACK_LANGUAGE = 'it';

// 'ro' -> 'Ro': suffisso dei campi dei modelli email (subjectRo, bodyHtmlRo)
export const fieldSuffix = (lang) => lang.charAt(0).toUpperCase() + lang.slice(1);
